<template>
    <highcharts :options="chartOptions"></highcharts>
  </template>  
  
  <script>
  import Highcharts from "highcharts";
  import {Chart} from "highcharts-vue";
  import { KassenprojektArtikel } from '@/backend_controller/kassenprojektArtikel';
  
  export default {
    components:{
        Chart
    },
    props:{
        kassenProjekt: {},
        dataAPI: []
    },
    data() {
      return {
        total: 0,
        dataMerch: [],
        chartOptions: null
        /*dataAPI: [
                  {
                      "artikelPreis": 66.60,
                      "artikelName": "Bier",
                      "anzahlVerkauft": 10
                  },
                  {
                      "artikelPreis": 33.30,
                      "artikelName": "Hefe",
                      "anzahlVerkauft": 5
                  },
              ]*/
        }
    },
    watch: {
      dataAPI: {
        handler(){
          this.prepareChart();
        },
        immediate: true
      }
    },
    methods: {
      prepareChart(){
        this.chartOptions = this.getChartData();
      },
      getChartData() {
        this.getDataFromAPI()
        console.log(this.$props.dataAPI);
        // console.log(this.total)
        return {
          chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: "pie"
          },
          title: {
            text: "<p style='font-size:40pt;'> Gesamt <br>" +this.total + "€</p>",
            align: 'center',
            verticalAlign: 'middle',
            x: 10,
            y: 15
          },
          tooltip: {
            // /pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
            useHTML: true,
              formatter: function () {
                  //console.log(this); // just to see , what data you can access
                  console.log(this.point);
                  return this.key + '<br>' 
                      + '</b> Prozent: <b>' + this.percentage.toFixed(2) + '% </b><br>'
                      + 'Anzahl verkauft: ' + this.point.amount + '<br>'
                      + 'Einnahmen: <b>' + this.point.money + '€</b>';
              }
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: "pointer",
              dataLabels: {
                enabled: true,
                //format: "<b>{point.name}</b>: {point.percentage:.1f} %",
                formatter: function() {
                  return this.key + '<br>' + this.percentage.toFixed(2) + '%'
                },
                style: {
                  color:
                    (Highcharts.theme && Highcharts.theme.contrastTextColor) ||
                    "black"
                }
              }
            }
          },
          series: 
          [
            {
              name: "Prozent",
              colorByPoint: true,
              innerSize: '50%',
              data: this.dataMerch,
            }
          ]
        }
      },
      getDataFromAPI() {
        this.dataMerch = []
        this.total = 0
        if (!this.$props.dataAPI || this.$props.dataAPI.length === 0) return;
        this.$props.dataAPI.forEach(element => {
          this.total = this.total + (+(element.artikelPreis) * +(element.anzahlVerkauft));
        })
        this.total = this.formatNumber(this.total)
        this.$props.dataAPI.forEach(element => {
          this.dataMerch.push({
            name: element.artikelName,
            y: +(+(element.artikelPreis)*+(element.anzahlVerkauft)),
            money: this.formatNumber(+(element.artikelPreis) * +(element.anzahlVerkauft)),
            amount: +(element.anzahlVerkauft)
          })
        })
      },
      formatNumber(amount, decimalCount = 2, decimal = ".", thousands = ",") {
        try {
            return amount.toFixed(2);
        } catch (e) {
          console.log(e)
        }
      }
    },
  };
  </script>
  

<style lang="scss">
.highcharts-title{
        font-size:medium !important;
        padding-left: 2rem !important;

        tspan{
          font-size:medium !important;
        }
    }

.highcharts-label{
    font-size: large !important;
}

.highcharts-credits{
  display: none;
}
</style>